import React from 'react'
import { Link } from 'react-router-dom';

function MatchQueueMetadata({ queue }) {
  return (
    <div className="row">
        <Link
        className="row-container"
        to={`/v2/admin/product-match/match-queues/${queue.slug}`}
        >
          <span className="queue-slug">
            {queue.slug}
          </span>
          <span className="description">
            Placeholder description for {queue.slug}
          </span>
        </Link>
    </div>
  )
}

export default MatchQueueMetadata
